import { useRouter } from 'next/router';
import { useMutation } from 'react-query';

import { useNotificationStore } from '@/common';
import { axios } from '@/library/axios';
import type { AddUserResponse, AddUserType } from '@/types/auth';

import { useAuth } from './auth';

export const addUser = async (
  userId: string,
  data: AddUserType
): Promise<AddUserResponse> => {
  return axios.post(`/customers/${userId}/profile`, data);
};

export const useAddUser = () => {
  const { addNotification } = useNotificationStore();
  const { userId } = useAuth();

  const router = useRouter();
  return useMutation({
    onSuccess: () => {
      addNotification({
        type: 'success',
        title: 'Success',
        message: 'User Registered Successfully',
      });
      router.push('/');
    },
    mutationFn: (data: AddUserType) => addUser(userId, data),
    useErrorBoundary: false,
  });
};
